<template>
  <div class="newVue">
    <!-- Chargement -->
    <div v-if="loadingGet" class="text-xs-center">
      <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
    </div>
    <div v-else>
      <v-expansion-panel>
        <v-expansion-panel-content
          v-for="(site, i) in mapping"
          :key="i"
          v-if="GET_SITE_BY_ID(site.LIC_ID)"
        >
          <div slot="header">{{ site.LIC_COMMENT }} <code>{{ site.LIC_URL }}</code></div>
          <v-card>
            <template>
            <v-card class="grey lighten-4 elevation-0">
              <v-card-text>
                <v-container fluid>
                  <!-- SELECTION DES AGENTS -->
                  <wz-select-agents
                    withoutMe
                    :agents.sync="mapping[i].LIC_USR_LIST"
                    :agentsInit="mapping[i].LIC_USR_LIST"
                  ></wz-select-agents>
                </v-container>
              </v-card-text>
            </v-card>
          </template>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </div>
    <div class="text-xs-right" v-if="!loadingGet">
      <v-btn
        color="primary"
        @click.native="submit"
        :loading="loadingPost"
      >
        {{ $t('save') | cap }}<v-icon dark right>send</v-icon>
      </v-btn>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import _ from 'lodash'
export default {
  data () {
    return {
      /**
       * indique si une requête ajax en cours
       * @type {Boolean}
       */
      loadingGet: false,
      loadingPost: false,
      /**
       * Tableau de tableaux du mapping des sites
       * @type {Array}
       */
      mapping: []
    }
  },
  created () {
    this.loadingGet = true
    this.axios.get('get/mapping.php')
    .then(response => {
      // formatage des données
      // pour chaque site mappé
      _.each(response.data, site => {
        let agents = []
        // pour chaque agent associé au site
        _.each(site[0].LIC_USR_LIST, agent => {
          let a = {
            USR_ID: agent[0],
            USR_FIRST_NAME: agent[1],
            USR_LAST_NAME: agent[2]
          }
          agents.push(a)
        })
        site[0].LIC_USR_LIST = agents
        this.mapping.push(site[0])
        // console.log('mapping -> this.mapping', this.mapping)
      })
    })
    .catch()
    .then(_ => {
      this.loadingGet = false
    })
  },
  methods: {
    /**
     *  Valide le formulaire et update la BDD
     */
    submit () {
      if (this.atLeastOneSitePerAgent.length) {
        let agents = this.atLeastOneSitePerAgent.map(agent => agent.USR_FIRST_NAME + ' ' + agent.USR_LAST_NAME)
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: this.$t('atLeastOneSitePerAgent') + ': ' + agents,
          context: 'error'
        })
        return
      }
      this.loadingPost = true
      // Données modifiées et à renvoyer
      let sites = []
      _.each(this.mapping, site => {
        sites.push({
          url: site.LIC_URL,
          id: site.LIC_ID,
          name: site.LIC_COMMENT,
          agentList: site.LIC_USR_LIST
        })
      })
      let dataToPost = new window.FormData()
      dataToPost.append('map', JSON.stringify(sites))
      this.axios.post('post/mapping.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifSuccess'), context: 'success' })
      })
      .catch(_ => {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifFailure'), context: 'error' })
      })
      .then(() => {
        this.loadingPost = false
      })
    }
  },
  computed: {
    ...mapGetters('_User', [ 'user' ]),
    ...mapState('_User', [ 'colleagues' ]),
    ...mapGetters('_Sites', [ 'GET_SITE_BY_ID' ]),
    /**
     * Vérifie que chaque agent est associé à au moins un site
     */
    atLeastOneSitePerAgent () {
      let map = this.mapping.map(map => map.LIC_USR_LIST)
      map = _.flatten(map)
      let agentHaveOnSite = this.colleagues.filter(colleague => {
        return !map.find(m => m.USR_ID === colleague.USR_ID)
      })
      return agentHaveOnSite
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/management/Mapping.vue